import React, { useEffect } from "react";
import BasedModal, { IProps } from "../BaseModalComponents/BasedModal";
import {
    ModalTitle,
    ModalDescription,
} from "components/AreYouSureModal/areYouSureModalStyles";
import { Container, ModalBody } from "components/NewGroupModal/styles";
import { getCellBackgroundWithErrorFlag } from "components/BasedTable/basedTableStyles";
import { useDispatch } from "react-redux";
import {
    initColorsFilter,
    saveColorsFilter,
    setColorsFilter,
} from "store/reducers/FilterSlice";
import { useAppSelector } from "hooks/redux";
import { Button } from "antd";

const bodyStyle = {
    paddingTop: 15,
    fontSize: 20,
    fontWeight: "bold",
    alignItems: "center",
    width: "400px",
    marginBottom: 15,
};

const style = {
    justifyContent: "space-evenly",
};

function ColorsPickerModal({
    isOpen,
    title,
    description,
    onRequestClose,
    id,
    onApplyClick,
}: IProps) {
    const dispatch = useDispatch();
    const checkboxValues = useAppSelector((state) => state.filter.colors[id]);

    useEffect(() => {
        if (!checkboxValues) {
            dispatch(
                initColorsFilter({
                    id,
                }),
            );
        }
    }, [id, checkboxValues, dispatch]);

    return (
        <BasedModal isOpen={isOpen} onRequestClose={onRequestClose}>
            <Container id="colors_picker_modal">
                <ModalBody style={bodyStyle as object}>
                    <ModalTitle>{title}</ModalTitle>
                    {description && (
                        <ModalDescription>{description}</ModalDescription>
                    )}
                </ModalBody>

                {/* [0, 1, 2, 3, 6] is actual error flags */}

                {checkboxValues &&
                    [0, 1, 2, 3, 4, 5, 6].map((errorFlag) => (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 10,
                                marginBottom: "10px",
                            }}
                            key={errorFlag}
                        >
                            <input
                                checked={checkboxValues[errorFlag]}
                                onChange={(e) => {
                                    const newColors = {
                                        ...checkboxValues,
                                        [errorFlag]: e.target.checked,
                                    };

                                    const colorsArray = Object.entries(
                                        newColors,
                                    )
                                        .filter(([_, value]) => value)
                                        .map(([key]) => Number(key));

                                    dispatch(
                                        setColorsFilter({
                                            id: id,
                                            key: errorFlag,
                                            value: e.target.checked,
                                        }),
                                    );

                                    dispatch(
                                        saveColorsFilter({
                                            id,
                                            colors: colorsArray,
                                        }),
                                    );
                                }}
                                type="checkbox"
                                style={{ width: 20, height: 20 }}
                            />
                            <div
                                style={{
                                    border: "1px solid #000",
                                    width: "80%",
                                    height: "20px",
                                    background:
                                        getCellBackgroundWithErrorFlag(
                                            errorFlag,
                                        ),
                                }}
                            ></div>
                        </div>
                    ))}

                <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button
                        style={{ width: "87%" }}
                        onClick={() =>
                            dispatch(
                                initColorsFilter({
                                    id: id,
                                    colors: [0, 1, 2, 3, 4, 5, 6],
                                }),
                            )
                        }
                    >
                        Сбросить
                    </Button>
                </div>
            </Container>
        </BasedModal>
    );
}

export default ColorsPickerModal;
